<template>
  <movimiento-caja-dialog
    :key="reload"
    tipo="RETIRO"
    @process-dinero="processDinero"
    @close-dialog="$emit('close-dialog')"
  />
</template>

<script>
import MovimientoCajaDialog from "@/components/caja/MovimientoCajaDialog.vue";
import { mapActions } from "vuex";

export default {
  name: "CajaRetiroEfectivo",
  components: { MovimientoCajaDialog },
  data() {
    return { reload: 0 };
  },
  methods: {
    ...mapActions("notificaciones", ["async_fetch_notificaciones"]),
    processDinero() {
      this.$emit("success-retirar");
      this.async_fetch_notificaciones().then(() => {
        this.reload += 1;
      });
    },
  },
};
</script>
